import { BookCard } from "@/components/books/BookCard";
import { RedactedText } from "@/components/redaction/RedactedText";
import { BOOKS } from "@/data/series";

export const BooksSection = () => (
  <section
    id="books"
    data-testid="books-section"
    className="relative z-10 scroll-mt-20 border-b border-border"
  >
    <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-24">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="eyebrow">Series index</p>
          <h2 className="mt-3 text-3xl font-semibold leading-tight sm:text-[2.6rem]">
            Six files. One still sealed.
          </h2>
        </div>
        <p className="max-w-sm text-sm leading-relaxed text-muted-foreground">
          Each book is told from inside a different civilisation. Read alone,
          each is a case. Read together, they are the same{" "}
          <RedactedText text="██████" />.
        </p>
      </div>

      <div
        className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5 lg:grid-cols-3"
        data-testid="books-grid"
      >
        {BOOKS.map((book) => (
          <BookCard key={book.number} book={book} />
        ))}
      </div>
    </div>
  </section>
);
